'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiMessage = function TiMessage(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 11.7c0.9 0 1.7 0.7 1.7 1.6v11.7c0 0.9-0.8 1.7-1.7 1.7h-14.7l-0.3 0.3v-0.3h-5c-0.9 0-1.7-0.8-1.7-1.7v-11.7c0-0.9 0.8-1.6 1.7-1.6h20z m0-3.4h-20c-2.7 0-5 2.3-5 5v11.7c0 2.8 2.3 5 5 5h1.7v5l5-5h13.3c2.8 0 5-2.2 5-5v-11.7c0-2.7-2.2-5-5-5z' })
        )
    );
};

exports.default = TiMessage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/message.js
// module id = 2126
// module chunks = 0